<template>
  <div class="links-wrapper">
    <ul class="links-list">
      <li v-for="(link, index) in links" :key="index">
        <router-link
          :to="link.siteUrl"
          class="link-route"
          @click.native="handleLinkClick(link, $event)"
        >
          {{ link.name }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Links",
  data() {
    return {
      links: [
        { name: "Home", siteUrl: "/" },
        { name: "Music", siteUrl: "/discography" },
        { name: "Tour", siteUrl: "/tour" },
        { name: "Merch", siteUrl: "/shop" },
        { name: "Band", siteUrl: "/about-us" },
        { name: "Contact Us!", siteUrl: "/contact" },
      ],
    };
  },
  methods: {
    handleLinkClick(link, event) {
      this.$emit("link-clicked");

      const resolvedPath = this.$router.resolve(link.siteUrl).route.path;
      if (this.$route.path === resolvedPath) {
        event.preventDefault();
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
.links-list {
  display: flex;
  flex-direction: row; /* Default to horizontal layout */
  gap: 24px;
  align-items: center;
  color: var(--gold);
  font-size: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.link-route {
  position: relative;
  display: inline-block;
  text-decoration: none;
  transition: color 0.3s ease;
}

.link-route:hover {
  color: white;
}

.link-route.router-link-exact-active {
  color: white;
}

.link-route::after {
  content: "";
  position: absolute;
  width: calc(100% + 10px);
  height: 1px;
  background-color: transparent;
  left: -5px;
  bottom: -3px;
  transition: background-color 0.3s ease;
}

.link-route:hover::after {
  background-color: white;
}

.link-route.router-link-exact-active::after {
  background-color: white;
}

@media (max-width: 768px) {
  .links-list {
    flex-direction: column;
  }
}
</style>
